import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useWhiteLabelling } from 'components/WhiteLabellingProvider';
import useIsApprovedUser from 'hooks/useIsApprovedUser';
import useUser from 'hooks/useUser';

const useInputsMarketQueryPaused = () => {
  const { isInputsType } = useWhiteLabelling();
  const { isSeller, user } = useUser();
  const isApprovedUser = useIsApprovedUser();
  const location = useLocation();
  const isMarketRoute = useMemo(() => location.pathname.includes('/market'), [location.pathname]);

  const isPaused = !isInputsType || !isMarketRoute || !isApprovedUser || isSeller || !user?.profileId;
  return isPaused;
};
export default useInputsMarketQueryPaused;
